import AnnouncementBanner from '@/announcement/components/AnnouncementBanner'
import ReleaseBanner from '@/release/components/ReleaseBanner'
import ImpersonationBanner from '@/superAdmin/components/ImpersonationBanner'
import { Box } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { TopBannersContext } from '../contexts/TopBannersContext'

interface Props {
  children: React.ReactNode
}

// 🔑 One fixed stack at the top of the window for every banner (#77). Each
// banner is an ordinary block inside it, so two banners stack instead of
// covering each other, and the stack's MEASURED height offsets the sidebar
// and the page: an announcement has no fixed height, unlike the impersonation
// banner which used to be the only one (#98).
export default function TopBanners({ children }: Props) {
  const ref = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const element = ref.current
    if (!element) return
    const observer = new ResizeObserver(() =>
      setHeight(element.getBoundingClientRect().height)
    )
    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  return (
    <TopBannersContext.Provider value={height}>
      <Box
        ref={ref}
        position="fixed"
        top={0}
        left={0}
        right={0}
        zIndex={2001}
        sx={{ '@media print': { display: 'none' } }}
      >
        <ImpersonationBanner />
        <AnnouncementBanner />
        <ReleaseBanner />
      </Box>
      {children}
    </TopBannersContext.Provider>
  )
}
